import { type SupportedLanguage, useLocale } from '@frontends/util-i18n';
import { useTheme } from '@frontends/util-theme-provider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useEntityConfig } from '@/hooks/useEntityConfig';

const ACUITY_LOCALES: Record<SupportedLanguage, string> = {
  'en-GB': 'en-GB',
  'zh-CN': 'zh-HK',
  'ar-SA': 'ar-AE',
  'ru-RU': 'ru-RU',
  'es-ES': 'es-ES',
  'de-DE': 'de-DE',
  'fr-FR': 'fr-FR',
  'pl-PL': 'pl-PL',
  'id-ID': 'id-ID',
  'ja-JP': 'ja-JP',
  'ko-KR': 'en-GB',
  'pt-PT': 'pt-PT',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'vi-VN': 'vi-vn',
};

export const TradingIdeas = () => {
  const { resolvedMode } = useTheme();
  const { t } = useTranslation();
  const config = useEntityConfig();
  const { locale } = useLocale();
  const language = locale.language;

  const tradingIdeasTheme =
    config.VITE_ENTITY === 'tradequo'
      ? resolvedMode === 'dark'
        ? 11313
        : 10097
      : resolvedMode === 'dark'
        ? 10368
        : 10509;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://prodstorage.azureedge.net/Widgets/lib/@1.0.0/widget-core.js';
    script.async = true;
    script.onload = () => {
      // @ts-ignore
      const globals = {
        apikey: '1fc3f5b3-1993-4bd9-925c-25f2b3b10624',
        locale: ACUITY_LOCALES[language],
      };

      // @ts-ignore
      if (window.AcuityWidgets) {
        // @ts-ignore
        window.AcuityWidgets.globals(globals);

        // @ts-ignore
        const widget = window.AcuityWidgets.CreateWidget(
          'acuityanalysisiq',
          document.getElementById('acuity-analysisiq'),
          { settingId: tradingIdeasTheme },
        );
        widget.mount();
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [tradingIdeasTheme, language]);

  return (
    <div>
      <div role="note" className="flex items-start gap-3 border-b bg-backgroundMuted px-4 py-3 md:px-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="mt-0.5 size-4 shrink-0 text-textSecondary"
        >
          <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
          <path d="M12 15h.01" />
          <path d="M12 7v4" />
        </svg>
        <p className="text-sm leading-relaxed text-textPrimary md:text-base">{t('trading_ideas_risk_disclaimer')}</p>
      </div>
      <div className="z-1" id="acuity-analysisiq"></div>
    </div>
  );
};
